import $axios from '@/utils/http'
import Base from './base'

export default class Test extends Base {

}